<mat-card *ngIf="activeMedication?.length && showActions" class="m-b-20">
    <mat-card-content class="p-b-0">
        <div class="list-header expandable" (click)="toggleHeader('active')">
            Active Medication
            <mat-icon aria-hidden="false" aria-label="Expand/Collapse">
                {{ expandedHeader === 'active' ? 'expand_less' : 'expand_more' }}
            </mat-icon>
        </div>
        <div *ngIf="expandedHeader === 'active'" class="full-width p-t-10">
            <div class="chip-container with-actions">
                <div class="medication-list">
                    <ng-container *ngFor="let med of activeMedication; let last = last">
                        <div class="medication-item">
                            <div>
                                <p>{{med.name || med.medication}}</p>
                                <p class="hint"> {{ med.dose }} {{ med.unit }} {{ med.frequency }}
                                    {{ med.duration }}</p>
                            </div>
                            <button mat-icon-button (click)="addMedicationItem(med)"
                                matTooltip="Add this medication to the prescription">
                                <mat-icon>content_copy</mat-icon>
                            </button>
                        </div>
                    </ng-container>
                </div>
            </div>
            <mat-divider></mat-divider>
            <div class="container-actions">
                <button mat-icon-button matTooltip="Create a prescription using the active medication"
                    (click)="bindMedicationList(activeMedication)">
                    <mat-icon>content_copy</mat-icon>
                </button>
            </div>
        </div>
    </mat-card-content>
</mat-card>

<mat-form-field appearance="outline" class="full-width" *ngIf="showActions">
    <mat-label>Medication Bundle</mat-label>
    <mat-select [formControl]="medicationBundleControl" (selectionChange)="selectMedicationBundle($event)">
        <mat-option *ngFor="let bundle of medicationBundles" [value]="bundle">
            {{ bundle.label }}
        </mat-option>
    </mat-select>
</mat-form-field>

<mat-form-field appearance="outline" class="full-width m-b-10">
    <mat-label>Search Medication</mat-label>
    <input matInput [formControl]="medicationControl" [matAutocomplete]="auto" #inputElement />
    <mat-hint class="hint">Search by name, active ingredient, or NAPPI code</mat-hint>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addMedicationItem($event.option.value)"
        requireSelection>
        <mat-option *ngFor="let item of filteredData | async" [value]="item" [class.generic]="item.isGeneric"
            class="medication-option">
            <div class="option-row">
                <ng-container *ngIf="getIconName(item.dosageForm) as icon">
                    <mat-icon *ngIf="icon.indexOf('svg-') === -1" [matTooltip]="item.dosageForm">{{ icon }}</mat-icon>
                    <mat-icon *ngIf="icon.indexOf('svg-') !== -1" [svgIcon]="icon.replace('svg-', '')"
                        [matTooltip]="item.dosageForm"></mat-icon>
                </ng-container>

                <div class="option-column">
                    <span>{{ item.name }} <ng-container *ngIf="item.schedule">({{item.schedule}})</ng-container>
                        <ng-container *ngIf="item.nappiCode"><small> -
                                NAPPI:{{item.nappiCode}}</small>
                        </ng-container>
                    </span>
                    <span *ngIf="item.ingredients?.length"><small>
                            Ingredients:
                            <ng-container *ngFor="let ingredient of item.ingredients">
                                <span class="m-r-5">
                                    {{ingredient.name}} {{ingredient.strength}}{{ingredient.unit}}
                                </span>
                            </ng-container> | Tablets/ml/Doses: {{item.packSize}} | Ind. Price: {{item.maxPrice}}
                        </small>
                    </span>
                </div>
            </div>
            <mat-divider></mat-divider>
        </mat-option>
        <mat-option *ngIf="(filteredData | async)?.length === 0 && medicationControl.value && searchCompleted">
            Can't find the item you are looking for? <a (click)="addManualMedication($event)">Add Manually.</a>
        </mat-option>
    </mat-autocomplete>
</mat-form-field>

<ng-container *ngIf="showActions">
    <h3 class="m-b-5 p-b-0">Active Prescription</h3>
    <p class="hint">
        Medication under Active Prescription is what will be prescribed. Add medication here from a medication bundle,
        copy them from the patients active medication list or search for a new one.
    </p>
</ng-container>
<div class="toggle-container" *ngIf="showActions && medicationList?.length ">
    <mat-slide-toggle [(ngModel)]="confirmSubstitutions" color="primary">Confirm Substitutions</mat-slide-toggle>
</div>

<div class="medication-container" *ngIf="medicationList?.length; else noMedicationMessage">
    <mat-accordion multi="false">
        <mat-expansion-panel *ngFor="let med of medicationList; let i = index" [expanded]="i === 0">
            <mat-expansion-panel-header>
                <mat-panel-title>{{med.name}}
                    <mat-icon class="expansion-header-icon" color="warn" matTooltip="Remove this medication"
                        (click)="deleteMedication($event, i)">delete</mat-icon>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="ingredient-row">

                <p *ngIf="med.ingredients?.length">
                    <ng-container *ngFor="let ingredient of med.ingredients">
                        <span class="m-r-10">
                            {{ingredient.name}} {{ingredient.strength}}{{ingredient.unit}}
                        </span>
                    </ng-container>
                </p>
                <div class="field-row medication-fields" *ngIf="med.id">

                    <mat-form-field appearance="outline">
                        <mat-label>Dose</mat-label>
                        <input matInput [(ngModel)]="med.dose" placeholder="Dose" type="number" min="0" required>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Unit</mat-label>
                        <input type="text" matInput [(ngModel)]="med.unit" [matAutocomplete]="autoUnit" required>
                        <mat-icon matSuffix *ngIf="!med.unit">search</mat-icon>
                        <mat-icon matSuffix *ngIf="med.unit" (click)="med.unit = ''" class="clickable">close</mat-icon>
                        <mat-autocomplete #autoUnit="matAutocomplete" [displayWith]="displayOption">
                            <mat-option *ngFor="let option of med.unitOptions" [value]="option">{{ option
                                }}</mat-option>
                        </mat-autocomplete>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Frequency</mat-label>
                        <input type="text" matInput [formControl]="med.frequencyControl"
                            [matAutocomplete]="autoFrequency" required>
                        <mat-icon matSuffix *ngIf="!med.frequencyControl.value">search</mat-icon>
                        <mat-icon matSuffix *ngIf="med.frequencyControl.value"
                            (click)="med.frequencyControl.setValue('')" class="clickable">close</mat-icon>
                        <mat-autocomplete #autoFrequency="matAutocomplete" [displayWith]="displayOption"
                            requireSelection>
                            <mat-option *ngFor="let option of med.filteredFrequencyOptions | async" [value]="option">{{
                                option.label
                                }}</mat-option>
                        </mat-autocomplete>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Route</mat-label>
                        <input type="text" matInput [formControl]="med.routeControl" [matAutocomplete]="autoRoute"
                            required>
                        <mat-icon matSuffix *ngIf="!med.routeControl.value">search</mat-icon>
                        <mat-icon matSuffix *ngIf="med.routeControl.value" (click)="med.routeControl.setValue('')"
                            class="clickable">close</mat-icon>
                        <mat-autocomplete #autoRoute="matAutocomplete" [displayWith]="displayOption" requireSelection>
                            <mat-option *ngFor="let option of med.filteredRouteOptions | async" [value]="option">{{
                                option.label
                                }}</mat-option>
                        </mat-autocomplete>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Duration</mat-label>
                        <input type="text" matInput [formControl]="med.durationControl" [matAutocomplete]="autoDuration"
                            required>
                        <mat-icon matSuffix *ngIf="!med.durationControl.value">search</mat-icon>
                        <mat-icon matSuffix *ngIf="med.durationControl.value" (click)="med.durationControl.setValue('')"
                            class="clickable">close</mat-icon>
                        <mat-autocomplete #autoDuration="matAutocomplete" [displayWith]="displayOption"
                            requireSelection>
                            <mat-option *ngFor="let option of med.filteredDurationOptions | async" [value]="option">{{
                                option.label
                                }}</mat-option>
                        </mat-autocomplete>
                    </mat-form-field>


                    <mat-form-field appearance="outline">
                        <mat-label>Repeat</mat-label>
                        <mat-select [(ngModel)]="med.repeat">
                            <mat-option [value]="0">Once Off</mat-option>
                            <mat-option [value]="1">1</mat-option>
                            <mat-option [value]="2">2</mat-option>
                            <mat-option [value]="3">3</mat-option>
                            <mat-option [value]="4">4</mat-option>
                            <mat-option [value]="5">5</mat-option>
                            <mat-option [value]="6">6</mat-option>
                        </mat-select>
                    </mat-form-field>

                </div>


                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Instructions</mat-label>
                    <input type="text" matInput [formControl]="med.instructionControl"
                        [matAutocomplete]="autoInstructions" [required]="med.frequencyControl.value?.value === 'PRN'">
                    <mat-icon matSuffix *ngIf="!med.instructionControl.value">search</mat-icon>
                    <mat-icon matSuffix *ngIf="med.instructionControl.value"
                        (click)="med.instructionControl.setValue('')" class="clickable">close</mat-icon>
                    <mat-autocomplete #autoInstructions="matAutocomplete" [displayWith]="displayOption">
                        <mat-option *ngFor="let option of med.filteredInstructions | async" [value]="option">{{
                            option
                            }}</mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <!-- <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Instructions</mat-label>
                    <input matInput [formControl]="med.instructionControl" placeholder="Instructions" type="text"
                        [matAutocomplete]="autoInstructions">
                    <mat-icon matSuffix *ngIf="!med.instructionControl.value">search</mat-icon>
                    <mat-icon matSuffix *ngIf="med.instructionControl.value"
                        (click)="med.instructionControl.setValue('')" class="clickable">close</mat-icon>
                    <mat-autocomplete #autoInstructions="matAutocomplete" [displayWith]="displayOption"
                        requireSelection>
                        <mat-option *ngFor="let option of med.filteredInstructions | async" [value]="option">
                            {{ option }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field> -->

            </div>
            <mat-divider></mat-divider>
            <p class="hint m-t-10" *ngIf="med.id"><strong>Schedule:</strong> {{med.schedule}} | <strong>Dosage
                    Form:</strong>
                {{med.dosageForm}} | <strong>Tablets/ml/Doses:</strong> {{med.packSize}} | <strong>Ind. Price:</strong>
                {{med.maxPrice}} | <strong>NAPPI:</strong> {{med.nappiCode}}</p>
        </mat-expansion-panel>
    </mat-accordion>
</div>

<!-- <ng-container *ngIf="showActions">
     <div class="field-row m-t-10" *ngIf="medicationList.length">
        <button mat-raised-button (click)="downloadPrescription()" color="primary" class="m-t-10">Download
            Script</button>
        <mat-form-field appearance="outline">
            <mat-label>Email</mat-label>
            <input matInput [(ngModel)]="email" placeholder="Email" type="email">
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>CC</mat-label>
            <input matInput [(ngModel)]="ccEmail" placeholder="Email" type="email">
        </mat-form-field>
        <button mat-raised-button (click)="emailPrescription()" color="primary" class="m-t-10">Email Script</button>
    </div> 
</ng-container> -->

<ng-template #authorizeSigningDialog>
    <h1 mat-dialog-title>Authorization Required</h1>
    <div mat-dialog-content>
        <div class="p-t-20 field-column">
            <p class="hint" *ngIf="isPhysicianUser">We require authorization in order to digitally sign this
                prescription since it contains medication listed schedule 5 or above. Please enter your password
                below.</p>

            <p class="hint" *ngIf="!isPhysicianUser">We require authorization in order to digitally sign this
                prescription. Please select the prescribing doctor and enter <strong>their</strong> password
                below.</p>

            <!-- The picker is for ADMIN STAFF signing on a doctor's behalf. A physician always signs as
                 themselves, so they see their own name instead — offering them a colleague let them enter
                 that colleague's password and then receive a silently unsigned script, because the server
                 (resolvePrescriptionAuthority) withholds the signature for doctor-to-doctor delegation. -->
            <mat-form-field appearance="outline" class="full-width" *ngIf="!isPhysicianUser">
                <mat-label>Requesting Physician</mat-label>
                <mat-select [(ngModel)]="signingAuthPhysician">
                    <mat-option *ngFor="let user of groupUsers" [value]="user.userId">{{user.title}} {{user.name}}
                        {{user.surname}}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width" *ngIf="isPhysicianUser">
                <mat-label>Signing as</mat-label>
                <input matInput [value]="currentUserDisplayName" readonly disabled>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Password</mat-label>
                <input matInput type="password" [(ngModel)]="signingAuthPassword" required>
            </mat-form-field>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-button mat-dialog-close>Cancel</button>
        <button mat-raised-button color="primary" [mat-dialog-close]="signingAuthPassword">Validate</button>
    </div>

</ng-template>

<ng-template #listLoading>
    <div class="list-loading">
        <mat-spinner color="primary" mode="indeterminate" diameter="20" style="float:right;"></mat-spinner>
    </div>
</ng-template>

<ng-template #noResults>
    <p class="no-records-message">No results found.</p>
</ng-template>


<ng-template #noMedicationMessage>
    <p class="no-records-message">No medication in the prescription list.</p>
</ng-template>